(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/set-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/set-suspension.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.spelpaus.logger;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const _svs$spelpaus$store$s = svs.spelpaus.store.suspension.actions,
  setActiveSuspensions = _svs$spelpaus$store$s.setActiveSuspensions,
  setHistorySuspensions = _svs$spelpaus$store$s.setHistorySuspensions;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const Button = svs.ui.ReactButton;
const _svs$spelpaus$constan = svs.spelpaus.constants,
  SUSPENSION_PRODUCTS = _svs$spelpaus$constan.SUSPENSION_PRODUCTS,
  SUSPENSION_PERIOD = _svs$spelpaus$constan.SUSPENSION_PERIOD,
  CALL_STATUS = _svs$spelpaus$constan.CALL_STATUS;
const _svs$spelpaus$pages$s = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper,
  getAvailableSuspensionPeriods = _svs$spelpaus$pages$s.getAvailableSuspensionPeriods,
  setNewSuspensionAsync = _svs$spelpaus$pages$s.setNewSuspensionAsync;
const _svs$spelpaus$pages$s2 = svs.spelpaus.pages.svsSuspension.SvsSuspensionService,
  getActiveSuspensionsAsync = _svs$spelpaus$pages$s2.getActiveSuspensionsAsync,
  getHistorySuspensionsAsync = _svs$spelpaus$pages$s2.getHistorySuspensionsAsync;
const ApproveInformation = svs.spelpaus.pages.svsSuspension.components.ApproveInformation;

const SetSuspension = () => {
  const dispatch = useDispatch();
  const activeSuspensions = ReactRedux.useSelector(state => state.suspension.activeSuspensions || []);
  const _React$useState = React.useState('0'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    product = _React$useState2[0],
    setProduct = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isProductError = _React$useState4[0],
    setIsProductError = _React$useState4[1];
  const _React$useState5 = React.useState('0'),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    period = _React$useState6[0],
    setPeriod = _React$useState6[1];
  const _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isPeriodError = _React$useState8[0],
    setIsPeriodError = _React$useState8[1];
  const _React$useState9 = React.useState([]),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    availableSuspensionPeriods = _React$useState0[0],
    setAvailableSuspensionPeriods = _React$useState0[1];
  const onClickButton = async e => {
    logger.debug('SetSuspension - onClickButton');
    e && e.preventDefault();
    let isValid = true;
    if (!SUSPENSION_PRODUCTS.find(item => item.id === product)) {
      isValid = false;
      setIsProductError(true);
    }
    if (!SUSPENSION_PERIOD.find(item => item.id === period)) {
      isValid = false;
      setIsPeriodError(true);
    }
    if (isValid) {
      logger.debug('*** onSubmitHandler OK!');
      const _await$setNewSuspensi = await setNewSuspensionAsync(product, Number(period)),
        status = _await$setNewSuspensi.status,
        suspensions = _await$setNewSuspensi.suspensions;
      logger.debug('*** back from setNewSuspensionAsync status, suspensions:', status, suspensions);
      if (status === CALL_STATUS.SUCCESS) {
        setProduct('0');
        setPeriod('0');
        if (suspensions) {
          logger.debug('*** suspensions OK!, dispatch-ing', suspensions);
          dispatch(setActiveSuspensions(suspensions));
        } else {
          const active = await getActiveSuspensionsAsync();
          dispatch(setActiveSuspensions(active));
        }
        const history = await getHistorySuspensionsAsync();
        dispatch(setHistorySuspensions(history));
      }
    }
  };
  const handleOnChangeProduct = e => {
    var _e$target, _e$target2;
    setProduct((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) || '0');
    setAvailableSuspensionPeriods(getAvailableSuspensionPeriods(activeSuspensions, e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value));
    setPeriod('0');
    setIsProductError(false);
    setIsPeriodError(false);
  };
  const handleOnChangePeriod = async e => {
    var _e$target3;
    setPeriod((e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value) || '0');
    setIsPeriodError(false);
  };
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "align-left"
  }, "H\xE4r kan du ta en spelpaus. V\xE4lj vilka spel du vill pausa dig fr\xE5n och hur l\xE4nge. Du kan v\xE4lja att pausa dig fr\xE5n alla spel, endast lotter och KenoXpress eller endast Vegas. Observera att varken du sj\xE4lv eller Svenska Spel kan h\xE4va en spelpaus i f\xF6rtid."), React.createElement(Form, {
    className: "align-left"
  }, React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja vad du vill pausa dig ifr\xE5n",
    hasError: isProductError,
    v2: true
  }, React.createElement(Select, {
    id: "selectProduct",
    label: "Vad vill du pausa dig ifr\xE5n?",
    onChange: handleOnChangeProduct,
    v2: true,
    value: product
  }, React.createElement(Option, {
    disabled: true,
    value: "0"
  }), SUSPENSION_PRODUCTS.map(p => React.createElement(Option, {
    key: p.id,
    value: p.id
  }, p.name)))), React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja en period",
    hasError: isPeriodError,
    v2: true
  }, React.createElement(Select, {
    id: "selectPeriod",
    label: "Hur l\xE4nge vill du pausa dig?",
    onChange: handleOnChangePeriod,
    v2: true,
    value: period
  }, React.createElement(Option, {
    disabled: true,
    value: "0"
  }), availableSuspensionPeriods.map(p => React.createElement(Option, {
    disabled: p.disabled,
    key: p.id,
    value: p.id
  }, p.period)))), React.createElement(ApproveInformation, null), React.createElement("div", {
    className: "grid-container-inner gutter-xs-1"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-2 margin-bottom-3",
    "data-test-id": "selectButton",
    inverted: true,
    onClick: onClickButton
  }, "Pausa"))));
};
svs.spelpaus.pages.svsSuspension.components.SetSuspension = SetSuspension;

 })(window);